import React from 'react';

function FlightsAddNewBySearch(){

    return (
        <>Add New Flights</>
    )

}

export default FlightsAddNewBySearch;